export default function CRMNotesIco() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="7.5" fill="#EBE1F9" />
      <path
        d="M34.6666 21.9998V17.0665C34.6666 14.8263 34.6666 13.7062 34.2306 12.8505C33.8471 12.0979 33.2352 11.486 32.4825 11.1025C31.6269 10.6665 30.5068 10.6665 28.2666 10.6665H19.7333C17.493 10.6665 16.3729 10.6665 15.5173 11.1025C14.7646 11.486 14.1527 12.0979 13.7692 12.8505C13.3333 13.7062 13.3333 14.8263 13.3333 17.0665V30.9332C13.3333 33.1734 13.3333 34.2935 13.7692 35.1491C14.1527 35.9018 14.7646 36.5137 15.5173 36.8972C16.3729 37.3332 17.493 37.3332 19.7333 37.3332H23.9999M26.6666 22.6665H18.6666M21.3333 27.9998H18.6666M29.3333 17.3332H18.6666M31.9999 35.9998V27.9998M27.9999 31.9998H35.9999"
        stroke="#7F56D9"
        stroke-width="2.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
